export default {"src":"/_next/static/media/football_own_goal.16f2d2fc.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};